$('.testimonial-slider-sec .testimonial-slider-inner').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0374/5946/0141/files/left-arrow.png?v=1706685980" alt="Previous"></button>',
  nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0374/5946/0141/files/next-arrow.png?v=1706685980" alt="Next"></button>',
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});